<!-- IMPRESSÃO -->
<ejs-dialog #modal [isModal]='true' 
    [header]="titulo" 
    [target]="'body'"
    [visible]="false"
    class="custom-dialog"
    [showCloseIcon]='true' 
    (open)='mostrarPdf = true;' 
    (close)='tratarFechamento()'
    [closeOnEscape]='true'>

    <ng-template #content>
        <div style='display: flex; flex-direction: column; height: 100%;'>
            <div style='flex-grow: 1;' *ngIf='mostrarPdf'>
                <ngx-extended-pdf-viewer #pdf [src]='arqPdf' [showUnverifiedSignatures]="true"
                    [showPresentationModeButton]="true" [useBrowserLocale]="true" height="100%">
                </ngx-extended-pdf-viewer>
            </div>
        </div>
    </ng-template>

</ejs-dialog>


